'use client'

import { reportClientError } from '@/lib/tracking'
import { useEffect } from 'react'

// Browser errors to GA4 as `client_error` (2026-10-23): a reader on a call
// saw an error on /storylines that a refresh cleared, and nothing on the
// server recorded it. Uncaught errors and unhandled promise rejections are
// reported here; the error pages (app/error.js, app/global-error.js) report
// what React caught.
export default function ErrorReporter() {
  useEffect(() => {
    const onError = (e) =>
      reportClientError(e.error || e.message, 'window', e.filename)
    const onRejection = (e) => reportClientError(e.reason, 'promise')
    window.addEventListener('error', onError)
    window.addEventListener('unhandledrejection', onRejection)
    return () => {
      window.removeEventListener('error', onError)
      window.removeEventListener('unhandledrejection', onRejection)
    }
  }, [])
  return null
}
